var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('HeaderLayout',{attrs:{"title":`${this.$store.getters.userInfo.tenant.shortName}分区计量全览图`,"workUrl":"/partition/workbench"}}),_c('mainWarp',{staticClass:"mainWarp",attrs:{"inputValue":_vm.value}}),_c('div',{staticClass:"main"},[_c('big-map-partition',{ref:"bigmap",attrs:{"code":"zone_metering_legend"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }